import { ArrowDownWideNarrow, ArrowUpWideNarrow } from '@boxicons/react';
import './sortDirectionButton.css';
import { SortDirection } from '@gdladder/shared/enums';

interface Props {
    direction: string;
    onChange: (direction: SortDirection) => void;
}

export default function SortDirectionButton({ direction, onChange }: Props) {
    const nextDirection: SortDirection = direction === 'asc' ? SortDirection.DESC : SortDirection.ASC;
    const label = direction === 'asc' ? 'Sort ascending' : 'Sort descending';

    return (
        <button
            type='button'
            className='sort-direction-button'
            aria-label={label}
            title={label}
            onClick={() => onChange(nextDirection)}
        >
            {direction === 'asc' ? <ArrowUpWideNarrow size='sm' /> : <ArrowDownWideNarrow size='sm' />}
        </button>
    );
}
